import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { BadgePercent, ArrowRight } from "lucide-react";

export const MemberStrip = () => (
  <motion.section
    data-testid="member-strip"
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 0.8 }}
    className="bg-charcoal py-5 text-bone"
  >
    <div className="mx-auto flex max-w-[1600px] flex-wrap items-center justify-center gap-x-8 gap-y-2 px-6 sm:px-10">
      <p className="flex items-center gap-3 text-xs uppercase tracking-[0.25em]">
        <BadgePercent size={16} className="text-powder" />
        Members save $25 on orders over $199
      </p>
      <Link
        to="/auth"
        data-testid="member-strip-cta"
        className="group flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-powder transition-colors duration-300 hover:text-bone"
      >
        Join free
        <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-1" />
      </Link>
    </div>
  </motion.section>
);
